
<iframe width="100%" [ngStyle]="{'height': getScreenHeight}" frameBorder="0" [src]="urlSafe"></iframe>
